// extracted by mini-css-extract-plugin
export default {"pageTitle":"tabs_pageTitle__blLh8","tabs":"tabs_tabs__jOsjm","selected":"tabs_selected__vhr+F","siteWidth":"tabs_siteWidth__RyCXs"};